(() => {
  if (window.nrouteEssentialCartEnhancementInitialized) return;
  window.nrouteEssentialCartEnhancementInitialized = true;

  const portalSelector = "#essential-cart-drawer-portal";
  const milestoneSelector = `${portalSelector} [data-essential-cart-element="reward-milestone"]`;
  const popupClass = "nroute-milestone-popup";
  const popupSettings = window.nrouteRewardPopupSettings || {};
  let previousMilestoneStates = null;
  let milestoneQueue = [];
  let pendingCartAddition = false;
  const milestoneTextByKey = new Map();
  const popupIndexByKey = new Map();
  const milestoneTextIndexes = [];

  (Array.isArray(popupSettings.milestoneTexts) ? popupSettings.milestoneTexts : []).forEach((value) => {
    if (typeof value !== "string" || !value.trim()) return;
    const normalized = value.trim().replace(/[\s₹,]/g, "").toLocaleLowerCase();
    if (!milestoneTextIndexes.some((entry) => entry.normalized === normalized)) {
      milestoneTextIndexes.push({ normalized, index: milestoneTextIndexes.length });
    }
  });

  const getMilestoneState = (milestone, index) => {
    const ariaLabel = milestone.getAttribute("aria-label") || "";
    const match = ariaLabel.match(/\b(unlocked|locked)\b/i);
    const visibleLabel =
      milestone
        .querySelector('[data-essential-cart-element="reward-milestone-label"]')
        ?.textContent?.trim() || "";
    const accessibleLabel = match
      ? ariaLabel.replace(match[0], "").replace(/^[\s:,-]+|[\s:,-]+$/g, "").trim()
      : "";
    const label = visibleLabel || accessibleLabel;
    const key = label.replace(/\s+/g, " ").toLocaleLowerCase();
    const customText =
      milestone.querySelector(":scope > .nroute-milestone-custom-text")?.textContent?.trim() || "";
    const normalizedCustomText = customText.replace(/[\s₹,]/g, "").toLocaleLowerCase();
    const matchingText = milestoneTextIndexes.find((entry) => entry.normalized === normalizedCustomText);
    const popupIndex = matchingText?.index ?? popupIndexByKey.get(key) ?? index;

    if (customText && key) {
      milestoneTextByKey.set(key, customText);
      popupIndexByKey.set(key, popupIndex);
    }

    return {
      index,
      label,
      status: match ? match[1].toLowerCase() : "",
      key,
      popupIndex,
    };
  };

  const getConfiguredMilestoneValue = (values, index) => {
    if (!Array.isArray(values)) return "";
    const configuredValues = values.filter((value) => typeof value === "string" && value.trim());
    return configuredValues[index]?.trim() || "";
  };

  const readMilestoneStates = () => {
    return Array.from(document.querySelectorAll(milestoneSelector))
      .map((milestone) => getMilestoneState(milestone))
      .filter((milestone) => milestone.label)
      .map((milestone, index) => ({
        ...milestone,
        index,
        popupIndex: milestone.popupIndex ?? index,
      }));
  };

  const updateMilestoneText = () => {
    let rewardMilestoneIndex = 0;
    document.querySelectorAll(milestoneSelector).forEach((milestone) => {
      const state = getMilestoneState(milestone);
      const index = state.label ? rewardMilestoneIndex++ : -1;
      const rememberedText = milestoneTextByKey.get(state.key);
      const customText =
        state.status === "locked"
          ? rememberedText || getConfiguredMilestoneValue(popupSettings.milestoneTexts, index)
          : "";
      const textElements = milestone.querySelectorAll(":scope > .nroute-milestone-custom-text");
      const textElement = textElements[0];

      textElements.forEach((duplicate, duplicateIndex) => {
        if (duplicateIndex > 0) duplicate.remove();
      });

      if (!customText) {
        textElement?.remove();
        return;
      }

      if (state.key) {
        milestoneTextByKey.set(state.key, customText);
        const normalizedCustomText = customText.replace(/[\s₹,]/g, "").toLocaleLowerCase();
        const matchingText = milestoneTextIndexes.find((entry) => entry.normalized === normalizedCustomText);
        if (matchingText) popupIndexByKey.set(state.key, matchingText.index);
      }

      if (!textElement) {
        const newTextElement = document.createElement("span");
        newTextElement.className = "nroute-milestone-custom-text";
        newTextElement.setAttribute("data-nroute-milestone-custom-text", "");
        milestone.prepend(newTextElement);
        newTextElement.textContent = customText;
        return;
      }

      if (textElement.textContent !== customText) textElement.textContent = customText;
    });
  };

  const formatRewardMessage = (rewardLabel) => {
    const rewardText = typeof rewardLabel === "string" && rewardLabel.trim() ? rewardLabel.trim() : "your reward";
    const template = popupSettings.messageTemplate || "You unlocked {{ reward_label }}!";
    return template.replace(/\{\{\s*reward_label\s*\}\}/gi, rewardText);
  };

  const closePopup = (popup) => {
    popup.remove();
    showNextPopup();
  };

  const showNextPopup = () => {
    if (document.body.querySelector(`.${popupClass}`) || milestoneQueue.length === 0) return;

    const popup = document.createElement("div");
    popup.className = popupClass;
    popup.setAttribute("role", "dialog");
    popup.setAttribute("aria-modal", "true");
    popup.setAttribute("aria-labelledby", "nroute-milestone-title");
    popup.setAttribute("aria-describedby", "nroute-milestone-message");

    const card = document.createElement("div");
    card.className = "nroute-milestone-popup__card";

    const confetti = document.createElement("div");
    confetti.className = "nroute-milestone-popup__confetti";
    confetti.setAttribute("aria-hidden", "true");
    for (let index = 0; index < 28; index += 1) {
      const piece = document.createElement("span");
      piece.style.setProperty("--confetti-index", `${index}`);
      piece.style.setProperty("--confetti-delay", `-${(index % 9) * 400}ms`);
      confetti.append(piece);
    }

    const closeButton = document.createElement("button");
    closeButton.className = "nroute-milestone-popup__close";
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", popupSettings.closeAriaLabel || "Close reward popup");
    closeButton.textContent = "×";

    const icon = document.createElement("div");
    icon.className = "nroute-milestone-popup__icon";
    icon.setAttribute("aria-hidden", "true");
    icon.textContent = "🎉";

    const title = document.createElement("h2");
    title.className = "nroute-milestone-popup__title";
    title.id = "nroute-milestone-title";
    const milestone = milestoneQueue.shift();
    const customTitle = getConfiguredMilestoneValue(popupSettings.milestonePopupTitles, milestone.popupIndex);
    title.textContent = customTitle || popupSettings.title || "You unlocked a reward!";

    const message = document.createElement("p");
    message.className = "nroute-milestone-popup__message";
    message.id = "nroute-milestone-message";
    const customMessage = getConfiguredMilestoneValue(popupSettings.milestonePopupTexts, milestone.popupIndex);
    message.textContent = customMessage || formatRewardMessage(milestone.label);

    const dismissButton = document.createElement("button");
    dismissButton.className = "nroute-milestone-popup__dismiss";
    dismissButton.type = "button";
    dismissButton.textContent = popupSettings.buttonLabel || "Awesome!";

    closeButton.addEventListener("click", () => closePopup(popup));
    dismissButton.addEventListener("click", () => closePopup(popup));
    popup.addEventListener("click", (event) => {
      if (event.target === popup) closePopup(popup);
    });
    popup.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closePopup(popup);
    });

    card.append(closeButton, icon, title, message, dismissButton);
    popup.append(confetti, card);
    document.body.append(popup);
    dismissButton.focus();
  };

  const scanMilestones = () => {
    updateMilestoneText();
    const current = readMilestoneStates();
    if (current.length === 0) return;

    if (previousMilestoneStates === null) {
      previousMilestoneStates = new Map(
        current
          .filter((milestone) => milestone.key)
          .map((milestone) => [
            milestone.key,
            { status: milestone.status, popupIndex: milestone.popupIndex },
          ]),
      );
      if (pendingCartAddition) {
        const unlockedMilestones = new Set();
        let highestUnlockedMilestone = null;
        current.forEach((milestone) => {
          if (
            milestone.label &&
            milestone.status === "unlocked" &&
            !unlockedMilestones.has(milestone.key)
          ) {
            unlockedMilestones.add(milestone.key);
            highestUnlockedMilestone = milestone;
          }
        });
        if (highestUnlockedMilestone) {
          milestoneQueue.push({
            popupIndex: highestUnlockedMilestone.popupIndex,
            label: highestUnlockedMilestone.label,
          });
        }
        pendingCartAddition = false;
        showNextPopup();
      }
      return;
    }

    const newlyUnlocked = new Set();
    current.forEach((milestone) => {
      if (
        milestone.label &&
        milestone.status === "unlocked" &&
        previousMilestoneStates.get(milestone.key)?.status === "locked" &&
        !newlyUnlocked.has(milestone.key)
      ) {
        milestoneQueue.push({
          popupIndex:
            previousMilestoneStates.get(milestone.key)?.popupIndex ?? milestone.popupIndex,
          label: milestone.label,
        });
        newlyUnlocked.add(milestone.key);
      }
    });
    previousMilestoneStates = new Map(
      current
        .filter((milestone) => milestone.key)
        .map((milestone) => [
          milestone.key,
          { status: milestone.status, popupIndex: milestone.popupIndex },
        ]),
    );
    pendingCartAddition = false;
    showNextPopup();
  };

  const openDrawerAfterAdd = () => {
    const cartApi = window.essentialCartApi;
    if (!cartApi || typeof cartApi.openCart !== "function") {
      console.error("[NRoute] Essential Cart API is unavailable after item-added.");
      return;
    }

    pendingCartAddition = true;
    if (typeof cartApi.isOpen !== "function" || !cartApi.isOpen()) {
      cartApi.openCart();
    }
  };

  scanMilestones();
  new MutationObserver(scanMilestones).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["aria-label"],
    childList: true,
    subtree: true,
  });

  document.addEventListener("essential-cart:item-added", openDrawerAfterAdd);
})();
